import { combineReducers } from 'redux';
import { filterReducer } from './filter';
import { checkPriceReducer } from './check_price';
import { globalReducer } from './global';
import { marketpriceReducer } from './marketprice';
import { getPopularReducer } from './popularReducer';
import { userReducer } from './userReducer';
import { amplitudeReducer } from './amplitudeReducer';

const reducer = combineReducers({
  filterReducer,
  checkPriceReducer,
  popular: getPopularReducer,
  user: userReducer,
  marketpriceReducer,
  globalReducer,
  amplitude: amplitudeReducer,
});

export default reducer;
